import { Announcement } from '@/modules/announcement/models/Announcement';
import { BaseEntityService } from '@/modules/core/app/services/abstracts/BaseEntityService';
import { Route } from '@/modules/core/app/constants/api.constants';
import AnnouncementResource from '@/modules/announcement/resources/AnnouncementResource';
import { commits } from '@/modules/core/app/helpers/store';
import { UploadImageResultObject } from '@/modules/announcement/models/UploadImageResultObject';

export class AnnouncementService extends BaseEntityService<Announcement> {
  getRoute(): string {
    return Route.ANNOUNCEMENTS;
  }

  getModel(): typeof Announcement {
    return Announcement;
  }

  addParams(params: Params = {}): Params {
    params.with = [
      'lastEditedByUser',
      'jurisdictions',
      'billingPlanMappings',
      'estateRoles',
      'professions',
      'countries',
      'excludedCompanies'
    ];

    return super.addParams(params);
  }

  async markAsSeen(ids: number[]): Promise<void> {
    await AnnouncementResource.markAsSeen(ids);

    commits.announcement.filterUnseenAnnouncements((announcement: Announcement) => {
      return !ids.includes(announcement.id);
    });

    return;
  }

  async uploadImage(file: Blob): Promise<UploadImageResultObject> {
    return UploadImageResultObject.mapModel(await AnnouncementResource.uploadImage(file));
  }
}

export default new AnnouncementService();
